import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { DownloadTokenResultDto, GetByIdsInputDto } from '../dtos/shared/models';
import type { GetStandCycleRotationsInputDto, StandCycleRotationCreateDto, StandCycleRotationDto, StandCycleRotationExcelDownloadDto, StandCycleRotationUpdateDto } from '../dtos/stand-cycle-rotation/models';

@Injectable({
  providedIn: 'root',
})
export class StandCycleRotationService {
  private restService = inject(RestService);
  apiName = 'Geographic';
  

  create = (input: StandCycleRotationCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, StandCycleRotationDto>({
      method: 'POST',
      url: '/api/geographic/standCycleRotations',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/geographic/standCycleRotations/${id}`,
    },
    { apiName: this.apiName,...config });
  

  deleteByIds = (ids: number[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/geographic/standCycleRotations',
      params: { ids },
    },
    { apiName: this.apiName,...config });
  

  get = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, StandCycleRotationDto>({
      method: 'GET',
      url: `/api/geographic/standCycleRotations/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getDownloadToken = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, DownloadTokenResultDto>({
      method: 'GET',
      url: '/api/geographic/standCycleRotations/download-token',
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetStandCycleRotationsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<StandCycleRotationDto>>({
      method: 'GET',
      url: '/api/geographic/standCycleRotations',
      params: { rotationId: input.rotationId, rotationName: input.rotationName, propertyTypeId: input.propertyTypeId, fomentContractId: input.fomentContractId, isFscCertified: input.isFscCertified, isPefcCertified: input.isPefcCertified, forestryStatusId: input.forestryStatusId, isInventoryValidated: input.isInventoryValidated, dab: input.dab, dabFrom: input.dabFrom, dabTo: input.dabTo, productivityParameterId: input.productivityParameterId, applyFeller: input.applyFeller, stumpApplicationId: input.stumpApplicationId, landContractId: input.landContractId, nextCycleEstimatedAge: input.nextCycleEstimatedAge, nextCycleEstimatedAgeFrom: input.nextCycleEstimatedAgeFrom, nextCycleEstimatedAgeTo: input.nextCycleEstimatedAgeTo, measurementTypeId: input.measurementTypeId, dualPercentage: input.dualPercentage, dualPercentageFrom: input.dualPercentageFrom, dualPercentageTo: input.dualPercentageTo, dualVolumeTree: input.dualVolumeTree, dualVolumeTreeFrom: input.dualVolumeTreeFrom, dualVolumeTreeTo: input.dualVolumeTreeTo, isStumpCandidateToRegrowth: input.isStumpCandidateToRegrowth, isRegrowthCandidate: input.isRegrowthCandidate, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListAsExcelFile = (input: StandCycleRotationExcelDownloadDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: '/api/geographic/standCycleRotations/as-excel-file',
      params: { downloadToken: input.downloadToken, fields: input.fields, rotationId: input.rotationId, rotationName: input.rotationName, propertyTypeId: input.propertyTypeId, fomentContractId: input.fomentContractId, isFscCertified: input.isFscCertified, isPefcCertified: input.isPefcCertified, forestryStatusId: input.forestryStatusId, isInventoryValidated: input.isInventoryValidated, dab: input.dab, dabFrom: input.dabFrom, dabTo: input.dabTo, productivityParameterId: input.productivityParameterId, applyFeller: input.applyFeller, stumpApplicationId: input.stumpApplicationId, landContractId: input.landContractId, nextCycleEstimatedAge: input.nextCycleEstimatedAge, nextCycleEstimatedAgeFrom: input.nextCycleEstimatedAgeFrom, nextCycleEstimatedAgeTo: input.nextCycleEstimatedAgeTo, measurementTypeId: input.measurementTypeId, dualPercentage: input.dualPercentage, dualPercentageFrom: input.dualPercentageFrom, dualPercentageTo: input.dualPercentageTo, dualVolumeTree: input.dualVolumeTree, dualVolumeTreeFrom: input.dualVolumeTreeFrom, dualVolumeTreeTo: input.dualVolumeTreeTo, isStumpCandidateToRegrowth: input.isStumpCandidateToRegrowth, isRegrowthCandidate: input.isRegrowthCandidate, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListByIds = (input: GetByIdsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, StandCycleRotationDto[]>({
      method: 'GET',
      url: '/api/geographic/standCycleRotations/by-ids',
      params: { ids: input.ids },
    },
    { apiName: this.apiName,...config });
  

  undoDelete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, StandCycleRotationDto>({
      method: 'POST',
      url: `/api/geographic/standCycleRotations/${id}/undo-delete`,
    },
    { apiName: this.apiName,...config });
  

  update = (id: number, input: StandCycleRotationUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, StandCycleRotationDto>({
      method: 'PUT',
      url: `/api/geographic/standCycleRotations/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });
}